import React, { useEffect, useState } from 'react';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';
import { recordDatalayerEvent } from '../../utilities/analytics';
import {
  getSignInUrl,
  NAV_DESKTOP,
  NAV_DESKTOP_UPDATED,
} from '../../utilities/constants';
import ProfileMenu from './profile-menu/ProfileMenu';
import HamburgerMenu from './hamburger-menu/HamburgerMenu';
import NavSection from './NavSection';
import ToggleWrapper from './ToggleWrapper';

function SignInLink() {
  return (
    <va-link-action
      data-testid="user-nav-sign-in-link"
      href={getSignInUrl().toString()}
      text="Sign in"
    />
  );
}
function Navbar() {
  const isActive = path => window.location.pathname.startsWith(path);
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const isClaimantDetailsUpdateEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalCdUpdateMain,
  );
  const navContent = isClaimantDetailsUpdateEnabled
    ? NAV_DESKTOP_UPDATED
    : NAV_DESKTOP;

  return navContent.map((link, i) => {
    return 'SECTIONS' in link ? (
      <ToggleWrapper
        toggleKey={link.FEATURE_FLAG_NAME}
        displayWhenDisabled={link.DISPLAY_WHEN_DISABLED}
        key={`nav-section-${i}`}
      >
        <NavSection link={link} />
      </ToggleWrapper>
    ) : (
      <ToggleWrapper
        toggleKey={link.FEATURE_FLAG_NAME}
        displayWhenDisabled={link.DISPLAY_WHEN_DISABLED}
        key={`nav-link-${i}`}
      >
        <a
          className={`nav__btn desktop ${isActive(link.URL) && 'is--active'}`}
          href={link.URL}
          data-testid={link.TEST_ID}
          onClick={recordDatalayerEvent}
          data-eventname="nav-link-click"
        >
          {link.LABEL}
        </a>
      </ToggleWrapper>
    );
  });
}
export const Nav = data => {
  const [isNavHidden, setIsNavHidden] = useState(true);
  const { profile } = data;
  useEffect(() => {
    const isAuthorized = localStorage.getItem('userAuthorized') === 'true';
    setIsNavHidden(!isAuthorized);
  }, []);

  return (
    <nav className="nav">
      <div className="nav__container nav__container-primary vads-u-display--flex">
        <a
          data-testid="nav-home-link"
          aria-label="VA Accredited Representative Portal"
          className="nav__link vads-u-display--flex"
          href="/representative"
          onClick={recordDatalayerEvent}
          data-eventname="nav-link-click"
        >
          <img
            data-testid="mobile-logo"
            className="nav__logo hide-on-desktop"
            src="/img/va.svg"
            alt="Veteran Affairs"
            data-eventname="nav-link-click"
          />
          <span className="nav__logo-text hide-on-desktop">
            Accredited Representative Portal
          </span>
          <img
            data-eventname="nav-link-click"
            data-testid="desktop-logo"
            className="nav__logo nav__logo--desktop hide-on-tablet"
            src="/img/arp-header-logo-dark.svg"
            alt="VA Accredited Representative Portal, U.S. Department of Veterans Affairs"
          />
        </a>

        <div className="heading-right">
          <a
            href="/representative/help"
            className={`usa-button-secondary heading-help-link  ${
              profile ? 'logged-in' : ''
            }`}
            data-testid="heading-help-link"
            onClick={recordDatalayerEvent}
            data-eventname="nav-link-click"
          >
            Help
          </a>
          {profile ? (
            <>
              <ProfileMenu profile={profile} />
              <HamburgerMenu />
            </>
          ) : (
            <SignInLink />
          )}
        </div>
      </div>

      {/* hidden if unauthorized */}
      {profile && (
        <div
          className={`nav__container-secondary ${
            isNavHidden ? 'vads-u-display--none' : 'is--displayed'
          }`}
          data-testid="desktop-nav-row"
        >
          <div className="nav__container vads-u-display--flex">
            <Navbar />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Nav;
